import Vue from 'vue';
import Router from 'vue-router';
import DashboardView from './views/DashboardView.vue';
import RunsView from './views/RunsView.vue';
import RunView from './views/RunView.vue';
import CreditsView from './views/CreditsView.vue';
import SettingsView from './views/SettingsView.vue';
import SigninView from './views/SigninView.vue';
import SignupView from './views/SignupView.vue';
import ResetPasswordView from './views/ResetPasswordView.vue';
import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: DashboardView,
      redirect: '/runs',
      children: [
        {
          path: '/runs',
          name: 'runs',
          component: RunsView,
          meta: { title: 'My Runs' },
        },
        {
          path: '/runs/:id',
          name: 'run',
          component: RunView,
        },
        {
          path: '/credits',
          name: 'credits',
          component: CreditsView,
          meta: { title: 'Credits' },
        },
        {
          path: '/settings',
          name: 'settings',
          component: SettingsView,
          meta: { title: 'Settings' },
        },
      ],
      meta: {
        requiresAuth: true,
      },
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
    {
      path: '/signin',
      name: 'signin',
      component: SigninView,
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignupView,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPasswordView,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next();
      return;
    }
    next('/signin');
  } else {
    next();
  }
});

export default router;
